import { useEffect, useRef, useState } from 'react';
import { ShareIcon } from 'src/assets/svgExports/ShareIcon';
import {
  PortalContainer,
  ShareOptionsContainer,
  SharOptionsBlock,
  SharOptionsSection,
} from '../Components/DesktopImageComponent/DesktopImageComponent.styles';
import { SHARE_OPTIONS } from '../Components/DesktopImageComponent/constants';
import {
  copyTextToClipboard,
  generateFacebookShareURL,
  generateTelegramShareLink,
  generateTwitterWebIntentURL,
  generateWhatsAppShareURL,
} from '@/utils/generateShareableURLS';
import { IS_DESKTOP } from 'src/utils/checkClientDeviceType';
import { toastNotifySuccess } from '@/components/Common/Toast';

const PdpShareOptions = ({ productData, showText = false, customWrapperClass = '' }) => {
  const shareRef = useRef();

  const [showAction, setShowAction] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (shareRef.current && !shareRef.current.contains(e.target)) {
        setShowAction(false);
      }
    };
    document.addEventListener('click', handler);
    return () => {
      document.removeEventListener('click', handler);
    };
  });

  const handleParentEvent = (e) => {
    e.stopPropagation();
  };
  const handleShareButtonAction = (e) => {
    setShowAction((state) => !state);
    setIsCopied(false);
  };

  const handleShareOptionAction = (choice) => {
    switch (choice) {
      case 'Copy Link':
        copyTextToClipboard(window.location.href, setIsCopied);
        break;
      case 'Facebook':
        {
          const url = generateFacebookShareURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Whatsapp':
        {
          const url = generateWhatsAppShareURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Twitter':
        {
          const url = generateTwitterWebIntentURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Telegram': {
        const url = generateTelegramShareLink(
          window.location.href,
          productData?.name,
          choice
        );
        window.open(url);
      }
      default:
        console.error('Please Select a valid option');
    }
  };

  const handleNativeShare = async () => {
    const contentForSharing = {
      title: productData?.name,
      url: window?.location?.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(contentForSharing);
      } else {
        copyTextToClipboard(window.location.href, setIsCopied);
        isCopied && toastNotifySuccess('Link is copied!!');
        console.warn('Web Share API not supported');
      }
    } catch (err) {
      copyTextToClipboard(window.location.href, setIsCopied);
      isCopied && toastNotifySuccess('Link is copied!!');
      console.error('Error Sharing', err);
    }
  };

  return (
    <div ref={shareRef} onClick={handleParentEvent}>
      <div onClick={IS_DESKTOP ? handleShareButtonAction : handleNativeShare}>
        <div
          className={`tw-flex tw-cursor-pointer tw-items-center ${customWrapperClass}`}
        >
          <ShareIcon />
          {showText && <span>Share</span>}
        </div>
      </div>
      {showAction && (
        <div className="relative">
          <ShareOptionsContainer>
            {SHARE_OPTIONS.map(({ id, portal, logo }, idx) => (
              <SharOptionsBlock
                key={id}
                lastIdx={idx + 1 === SHARE_OPTIONS.length ? SHARE_OPTIONS.length : ''}
              >
                <SharOptionsSection onClick={() => handleShareOptionAction(portal)}>
                  <img src={logo} />
                  <PortalContainer
                    portal={portal === 'Copy Link' && isCopied ? 'Link Copied' : portal}
                  >
                    {portal === 'Copy Link' && isCopied ? 'Link Copied' : portal}
                  </PortalContainer>
                </SharOptionsSection>
              </SharOptionsBlock>
            ))}
          </ShareOptionsContainer>
        </div>
      )}
    </div>
  );
};

export default PdpShareOptions;
